import { Avatar, ButtonBase, Divider, Menu, MenuItem, Stack, Typography } from '@mui/material'
import { useState } from 'preact/hooks'
import { initials } from '../conversations/format'
import { useSession } from './session'

/**
 * The user's avatar, opening the account menu: profile, logout. `withName` shows the name next
 * to the avatar from tablet width, `subtitle` always, with the subtitle under it.
 */
export function AccountMenu({
  subtitle,
  withName = false,
}: {
  subtitle?: string
  withName?: boolean
}) {
  const { me, logout } = useSession()
  const [anchor, setAnchor] = useState<HTMLElement | null>(null)
  const name = me?.display_name ?? me?.email ?? me?.phone ?? ''
  const close = () => setAnchor(null)
  return (
    <>
      <ButtonBase
        aria-label="Mon compte"
        aria-haspopup="menu"
        onClick={(e) => setAnchor(e.currentTarget as HTMLElement)}
        sx={{ gap: 1.25, borderRadius: 3, p: subtitle ? 1.5 : 0, justifyContent: 'flex-start' }}
      >
        <Avatar
          sx={{
            width: 34,
            height: 34,
            fontSize: 13,
            fontWeight: 700,
            bgcolor: 'primary.light',
            color: 'primary.main',
          }}
        >
          {initials(name)}
        </Avatar>
        {(subtitle || withName) && (
          <Stack
            sx={{
              minWidth: 0,
              textAlign: 'left',
              display: subtitle ? 'flex' : { xs: 'none', sm: 'flex' },
            }}
          >
            <Typography variant="body2" noWrap sx={{ fontWeight: 600, maxWidth: 200 }}>
              {name}
            </Typography>
            {subtitle && (
              <Typography variant="caption" color="text.secondary">
                {subtitle}
              </Typography>
            )}
          </Stack>
        )}
      </ButtonBase>
      <Menu anchorEl={anchor} open={anchor !== null} onClose={close}>
        <MenuItem component="a" href="/profile" onClick={close}>
          Mon profil
        </MenuItem>
        <Divider />
        <MenuItem
          onClick={() => {
            close()
            void logout()
          }}
        >
          Se déconnecter
        </MenuItem>
      </Menu>
    </>
  )
}
